import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import PrimaryBtn from "../../components/atoms/button/primaryBtn";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import Radio from "../../components/atoms/input/radio";
import Checkbox from "../../components/atoms/input/checkbox";
import PretendardText from "../../components/atoms/text/pretendardText";
import { tabList } from "./../../constant/myPageTab";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import RetiredApi from "../../api/retired.api";
import { toast } from "react-toastify";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { errorHandler } from "../../util/errorHandler";
import MemberApi from "../../api/member.api";
import TermApi from "../../api/term.api";

const MyPageSettingWithdrawal = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [memberNickname, setMemberNickname] = useState("회원");
  const [termData, setTermData] = useState({});

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_setting_withdrawal,
        )}`,
        { replace: true },
      );
      return;
    }

    getWithdrawalInfo();
  }, [navigate]);

  const getWithdrawalInfo = async () => {
    try {
      const [memberResponse, termResponse] = await Promise.all([
        MemberApi.getMyInfo(),
        TermApi.getDetail(8),
      ]);
      setMemberNickname(
        memberResponse.data.data.content?.nickname?.trim() || "회원",
      );
      setTermData(termResponse.data.data.content ?? {});
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 모바일 버전 탭 관련 ---------- //
  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[0].title);

  // ---------- 체크 관련 ---------- //
  const withdrawReasonList = [
    "서비스를 사용하기가 너무 어려워요.",
    "서비스에서 불쾌한 경험을 했어요.",
    "원하는 서비스가 없어요.",
    "자주 사용하지 않아요.",
  ];

  const [withdrawalReason, setWithdrawalReason] = useState(
    withdrawReasonList[0],
  );

  const [agreement, setAgreement] = useState(false);

  // ---------- 모달 관련 ---------- //
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ---------- 탈퇴 관련 ---------- //
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleWithdrawal = async () => {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      const data = {
        reason: withdrawalReason,
      };

      await RetiredApi.createRetired(data);
      sessionStorage.clear();
      toast("회원 탈퇴가 완료되었습니다.");
      navigate(route.home, { replace: true });
    } catch (error) {
      errorHandler(error);
      setIsModalOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const dummyText = (
    <>
      회원가입 시 입력한 정보는 ‘개인정보 보호 정책’에 따라 90일간 보관되며,
      90일이 경과된 후에는 모든 정보가 삭제됩니다. 수강 중인 강의 및 회원 계정에
      남아있는 정보와 쿠폰 등은 모두 삭제되며 재가입 시에도 복구되지 않습니다.
      핀라이브(이하 ‘회사’라 한다)은 개인정보 보호법 제30조에 따라 정보 주체의
      개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록
      하기 위하여 다음과 같이 개인정보 처리지침을 수립, 공개합니다. 제1조
      (개인정보의 처리목적) 회사는 다음의 목적을 위하여 개인정보를 처리합니다.
      처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용
      목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는
      등 필요한 조치를 이행할 예정입니다. 1. 홈페이지 회원 가입 및 관리 회원
      가입 의사 확인, 회원제 서비스 제공에 따른 본인 식 별․인증, 회원자격
      유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정 이용 방지,
      만 14세 미만 아동의 개인정보처리 시 법정대리인의 동의 여부 확인, 각종
      고지․통지, 고충 처리 등을 목적으로 개인정보를 처리합니다. 2. 재화 또는
      서비스 제공 물품 배송, 서비스 제공, 계약서 및 청구서 발송, 콘텐츠 제공,
      맞춤서비스 제공, 본인인증, 연령인증, 요금 결제 및 정산, 채권추심 등을
      목적으로 개인정보를 처리합니다. 3. 고충 처리 민원인의 신원 확인, 민원사항
      확인, 사실조사를 위한 연락․통지, 처리 결과 통보 등의 목적으로 개인정보를
      처리합니다. 제2조 (개인정보의 처리 및 보유기간) ① 회사는 법령에 따른
      개인정보 보유, 이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의
      받은 개인정보 보유, 이용 기간 내에서 개인정보를 처리, 보유합니다. ② 각각의
      개인정보 처리 및 보유 기간은 다음과 같습니다. 1. 홈페이지 회원 가입 및
      관리 : 사업자/단체 홈페이지 탈퇴 시까지 다만, 다음의 사유에 해당하는
      경우에는 해당 사유 종료 시까지 1) 관계 법령 위반에 따른 수사, 조사 등이
      진행 중인 경우에는 해당 수사, 조사 종료 시까지 2) 홈페이지 이용에 따른
      채권 및 채무관계 잔존 시에는 해당 채권, 채무 관계 정산 시까지 2. 재화 또는
      서비스 제공 : 재화․서비스 공급완료 및 요금결제․정산 완료 시까지 다만,
      다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지 1) 「전자상거래
      등에서의 소비자 보호에 관한 법률」에 따른 표시․광고, 계약내용 및 이행 등
      거래에 관한 기록 - 표시․광고에 관한 기록 : 6월 - 계약 또는 청약 철회,
      대금결제, 재화 등의 공급기록 : 5년 - 소비자 불만 또는 분쟁 처리에 관한
      기록 : 3년 2) 「통신비밀보호법」 제41조에 따른 통신사실확인자료 보관 -
      가입자 전기통신일시, 개시․종료 시간, 상대방 가입자 번호, 사용도수,
      발신기지국 위치추적자료 : 1년 - 컴퓨터 통신, 인터넷 로그 기록자료, 접속지
      추적자료 : 3개월 제3조 (개인정보의 제3자 제공) ① 회사는 정보주체의
      개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며,
      정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는
      경우에만 개인정보를 제3자에게 제공합니다. ② 회사는 다음과 같이 개인정보를
      제3자에게 제공하고 있습니다. - 개인정보를 제공받는 자 : &gt;예) (주) OOO
      카드&gt; - 제공받는 자의 개인정보 이용목적 : &gt;예) 이벤트 공동개최 등
      업무제휴 및 제휴 신용카드 발급&gt; - 제공하는 개인정보 항목 : &gt;예)
      성명, 주소, 전화번호, 이메일주소, 카드결제계좌정보&gt; - 제공받는 자의
      보유, 이용기간 : &gt;예) 신용카드 발급계약에 따른 거래기간동안&gt;
      제4조(개인정보처리의 위탁) ① 회사는 원활한 개인정보 업무처리를 위하여
      다음과 같이 개인정보 처리업무를 위탁하고 있습니다. ② 회사는 위탁계약 체결
      시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
      기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등
      책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게
      처리하는지를 감독하고 있습니다. ③ 위탁업무의 내용이나 수탁자가 변경될
      경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
      제5조(이용자 및 법정대리인의 권리와 그 행사 방법) ① 정보주체는 회사에 대해
      언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다. 1.
      개인정보 열람 요구 2. 오류 등이 있을 경우 정정 요구 3. 삭제요구 4.
      처리정지 요구 ② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편,
      모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이
      조치하겠습니다. ③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를
      요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를
      이용하거나 제공하지 않습니다. ④ 제1항에 따른 권리 행사는 정보주체의
      법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우
      개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야
      합니다. ⑤ 정보주체는 개인정보 보호법 등 관계 법령을 위반하여 회사가
      처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는
      아니 됩니다. 제6조(처리하는 개인정보 항목) 회사는 다음의 개인정보 항목을
      처리하고 있습니다. 1. 홈페이지 회원 가입 및 관리 필수항목 : &gt;예) 성명,
      생년월일, 아이디, 비밀번호, 주소, 전화번호, 성별, 이메일주소,
      아이핀번호&gt; 선택항목 : &gt;예) 결혼 여부, 관심 분야&gt; 2. 재화 또는
      서비스 제공 필수항목 : &gt;예) 성명, 생년월일, 아이디, 비밀번호, 주소,
      전화번호, 이메일주소, 아이핀번호, 신용카드번호, 은행계좌정보 등
      결제정보&gt; 선택항목 : &gt;관심분야, 과거 구매내역&gt; 3. 인터넷 서비스
      이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.
      IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등
      제7조(개인정보의 파기) ① 회사는 개인정보 보유 기간의 경과, 처리목적 달성
      등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를
      파기합니다. ② 정보주체로부터 동의받은 개인정보 보유 기간이 경과하거나
      처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속
      보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로
      옮기거나 보관장소를 달리하여 보존합니다. ③ 개인정보 파기의 절차 및 방법은
      다음과 같습니다. 1. 파기 절차 회사는 파기 사유가 발생한 개인정보를
      선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
      2. 파기 방법 회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을
      재생할 수 없도록 로우레밸포멧(Low Level Format) 등의 방법을 이용하여
      파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여
      파기합니다. 제8조(개인정보의 안전성 확보조치) 회사는 개인정보의 안전성
      확보를 위해 다음과 같은 조치를 하고 있습니다. 1. 관리적 조치 :
      내부관리계획 수립 및 시행, 정기적 직원 교육 등 2. 기술적 조치 :
      개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 고유 식별정보
      등의 암호화, 보안프로그램 설치 3. 물리적 조치 : 전산실, 자료보관실 등의
      접근통제 제9조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항) ①
      회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고
      수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. ② 쿠키는 웹사이트를
      운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에 보내는 소량의
      정보이며 이용자들의 컴퓨터 내의 하드디스크에 저장되기도 합니다. 가. 쿠키의
      사용 목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및
      이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된
      정보 제공을 위해 사용됩니다. 나. 쿠키의 설치∙운영 및 거부 : 웹브라우저
      상단의 도구&gt;인터넷 옵션&gt;개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을
      거부 할 수 있습니다. 다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에
      어려움이 발생할 수 있습니다. 제10조(개인정보 처리방침 시행 및 변경) 이
      개인정보 처리방침은 &gt;사이트 개설일&gt;부터 적용됩니다.
    </>
  );

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 0 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentWrapper>
                  <LSBdDisplay02 style={{ color: "#5050FF", marginBottom: 4 }}>
                    정말 핀라이브를 탈퇴하실건가요?
                  </LSBdDisplay02>
                  <LSRgH2HeadLine
                    style={{ color: "#101113", marginBottom: 30 }}
                  >
                    {memberNickname} 님의 탈퇴 이유를 알려주세요, 탈퇴 시 모든
                    데이터는 복구가 불가능해요 😢
                  </LSRgH2HeadLine>

                  {/* 본문 영역 - 라디오 체크박스 영역 */}
                  <RadioWrapper>
                    <Radio
                      id="reason01"
                      name="reason01"
                      checked={withdrawalReason === withdrawReasonList[0]}
                      value={withdrawReasonList[0]}
                      valueText={withdrawReasonList[0]}
                      onChange={() => {
                        setWithdrawalReason(withdrawReasonList[0]);
                      }}
                    />
                    <Radio
                      id="reason02"
                      name="reason02"
                      checked={withdrawalReason === withdrawReasonList[1]}
                      value={withdrawReasonList[1]}
                      valueText={withdrawReasonList[1]}
                      onChange={() => {
                        setWithdrawalReason(withdrawReasonList[1]);
                      }}
                    />
                    <Radio
                      id="reason03"
                      name="reason03"
                      checked={withdrawalReason === withdrawReasonList[2]}
                      value={withdrawReasonList[2]}
                      valueText={withdrawReasonList[2]}
                      onChange={() => {
                        setWithdrawalReason(withdrawReasonList[2]);
                      }}
                    />
                    <Radio
                      id="reason04"
                      name="reason04"
                      checked={withdrawalReason === withdrawReasonList[3]}
                      value={withdrawReasonList[3]}
                      valueText={withdrawReasonList[3]}
                      onChange={() => {
                        setWithdrawalReason(withdrawReasonList[3]);
                      }}
                    />
                  </RadioWrapper>

                  <TermsContainer>
                    <LSBdDisplay02 style={{ color: "#000", marginBottom: 30 }}>
                      {termData.title || "개인정보처리방침"}
                    </LSBdDisplay02>
                    <TermsWrapper className="hide-scrollbar">
                      <PretendardText
                        style={{
                          fontWeight: 700,
                          fontSize: 14,
                          lineHeight: "16.71px",
                          color: "#8C8C8C",
                          marginBottom: 14,
                        }}
                      >
                        [ ⚠ 탈퇴 유의사항 ]
                      </PretendardText>
                      {/* 나중에 이곳에 텍스트 에디터 입력 정보 넣어야 함 */}
                      <PretendardText
                        style={{
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "16.71px",
                          color: "#8C8C8C",
                        }}
                      >
                        {termData.content || dummyText}
                      </PretendardText>
                    </TermsWrapper>
                  </TermsContainer>

                  <Checkbox
                    id="withdrawalAgree"
                    name="withdrawalAgree"
                    checked={agreement}
                    value="회원 탈퇴 전 유의사항을 모두 확인하였으며 동의합니다."
                    valueText="회원 탈퇴 전 유의사항을 모두 확인하였으며 동의합니다."
                    onChange={(e) => {
                      setAgreement(e.target.checked);
                    }}
                    required={true}
                    style={{ marginTop: 20 }}
                  />

                  <WithdrawalBtnWrapper>
                    <PrimaryBtn
                      style={{
                        backgroundColor: "#F24147",
                      }}
                      btnText="회원 탈퇴"
                      onClick={() => {
                        if (!agreement) {
                          toast("탈퇴 유의사항에 동의해주세요.");
                          return;
                        }

                        setIsModalOpen(true);
                      }}
                    />
                  </WithdrawalBtnWrapper>
                </ContentWrapper>
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {isMobile && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={tabList}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>

            <ContentWrapper>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  marginBottom: 30,
                }}
              >
                <LSBdH1HeadLine style={{ color: "#5050FF" }}>
                  정말 핀라이브를 탈퇴하실건가요?
                </LSBdH1HeadLine>
                <LSRgCaption02 style={{ color: "#101113" }}>
                  {memberNickname} 님의 탈퇴 이유를 알려주세요,
                  <br />
                  탈퇴 시 모든 데이터는 복구가 불가능해요 😢
                </LSRgCaption02>
              </div>

              {/* 본문 영역 - 라디오 체크박스 영역 */}
              <RadioWrapper $isSmall={isSmall}>
                <Radio
                  isSmall={true}
                  id="reason01"
                  name="reason01"
                  checked={withdrawalReason === withdrawReasonList[0]}
                  value={withdrawReasonList[0]}
                  valueText={withdrawReasonList[0]}
                  onChange={() => {
                    setWithdrawalReason(withdrawReasonList[0]);
                  }}
                />
                <Radio
                  isSmall={true}
                  id="reason02"
                  name="reason02"
                  checked={withdrawalReason === withdrawReasonList[1]}
                  value={withdrawReasonList[1]}
                  valueText={withdrawReasonList[1]}
                  onChange={() => {
                    setWithdrawalReason(withdrawReasonList[1]);
                  }}
                />
                <Radio
                  isSmall={true}
                  id="reason03"
                  name="reason03"
                  checked={withdrawalReason === withdrawReasonList[2]}
                  value={withdrawReasonList[2]}
                  valueText={withdrawReasonList[2]}
                  onChange={() => {
                    setWithdrawalReason(withdrawReasonList[2]);
                  }}
                />
                <Radio
                  isSmall={true}
                  id="reason04"
                  name="reason04"
                  checked={withdrawalReason === withdrawReasonList[3]}
                  value={withdrawReasonList[3]}
                  valueText={withdrawReasonList[3]}
                  onChange={() => {
                    setWithdrawalReason(withdrawReasonList[3]);
                  }}
                />
              </RadioWrapper>

              <TermsContainer $isSmall={isSmall}>
                <LSBdDisplay02 style={{ color: "#000", marginBottom: 30 }}>
                  {termData.title || "개인정보처리방침"}
                </LSBdDisplay02>
                <TermsWrapper className="hide-scrollbar">
                  <PretendardText
                    style={{
                      fontWeight: 700,
                      fontSize: 14,
                      lineHeight: "16.71px",
                      color: "#8C8C8C",
                      marginBottom: 14,
                    }}
                  >
                    [ ⚠ 탈퇴 유의사항 ]
                  </PretendardText>
                  {/* 나중에 이곳에 텍스트 에디터 입력 정보 넣어야 함 */}
                  <PretendardText
                    style={{
                      fontWeight: 400,
                      fontSize: 14,
                      lineHeight: "16.71px",
                      color: "#8C8C8C",
                    }}
                  >
                    {termData.content || dummyText}
                  </PretendardText>
                </TermsWrapper>
              </TermsContainer>

              <Checkbox
                isSmall={true}
                id="withdrawalAgree"
                name="withdrawalAgree"
                checked={agreement}
                value="회원 탈퇴 전 유의사항을 모두 확인하였으며 동의합니다."
                valueText="회원 탈퇴 전 유의사항을 모두 확인하였으며 동의합니다."
                onChange={(e) => {
                  setAgreement(e.target.checked);
                }}
                required={true}
                style={{ marginTop: 15 }}
              />

              <WithdrawalBtnWrapper $isSmall={isSmall}>
                <PrimaryBtn
                  style={{
                    backgroundColor: "#F24147",
                  }}
                  btnText="회원 탈퇴"
                  onClick={() => {
                    if (!agreement) {
                      toast("탈퇴 유의사항에 동의해주세요.");
                      return;
                    }

                    setIsModalOpen(true);
                  }}
                />
              </WithdrawalBtnWrapper>
            </ContentWrapper>
          </ContentContainer>
        </MOContainer>
      )}

      {/* 모달 */}
      {isModalOpen && (
        <ConfirmModal
          isScroll={false}
          title={"회원탈퇴"}
          content={
            "탈퇴 시 수강 중인 강의 및 회원 계정에 남아있는 정보와 쿠폰 등은 모두 삭제됩니다."
          }
          isNegative={true}
          yText={isSubmitting ? "탈퇴 처리 중..." : "동의 및 회원 탈퇴"}
          onClick={() => {
            setIsModalOpen(false);
          }}
          onYClick={() => {
            handleWithdrawal();
          }}
        />
      )}
    </HomeSection>
  );
};

export default MyPageSettingWithdrawal;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  padding: ${(props) => (props.$isSmall ? "0px" : "60px 40px")};
  display: flex;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  box-shadow: ${(props) =>
    props.$isSmall ? "" : "0px 0px 6px rgba(0, 0, 0, 0.1)"};
  border-radius: ${(props) => (props.$isSmall ? "" : "30px")};
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 40px;
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;

const RadioWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "20px")};
`;

const TermsContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "100%" : "915px")};
  height: 440px;
  padding: 40px;
  background-color: #f6f7f8;
  border-radius: 30px;
  margin-top: 32px;
`;

const TermsWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(props) => (props.$isSmall ? "392px" : "296px")};
  overflow-y: scroll;
  overflow-x: hidden;
`;

const WithdrawalBtnWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: 100%;
  margin: ${(props) =>
    props.$isSmall ? "28px 0px 0px 0px" : "50px 0px 40px 0px"};
`;
